<template>
  <div class="live-event-component"
       :idfoevent="event.idfoevent.toString()"
       :idfosbevent="event.idfosbevent && event.idfosbevent.toString()"
       :idextevent="event.idextevent && event.idextevent.toString()">

    <div v-if="isDebug" class="debug">
      idfoevent {{ event.idfoevent }}<br />
      idfosbevent {{ event.idfosbevent }}<br />
      eventdisplayorder {{ event.eventdisplayorder }} <br />
      eventrows {{ event.eventrows }}
    </div>

    <div class="flex-row">
      <div class="event-info" v-if="awayPlayer && homePlayer && !event.isoutright">

        <div class="info-head">
          <h2 class="sport-name" v-if="showheader === undefined || showheader">
            <img v-if="(brand_translux4 && !isSportIconAvailableForTranslux4) || brand_translux3 || brand_translux2" class="logo" src="static/img/logo-event.png" alt="Logo">
            <icon v-if="brand_translux4 && isSportIconAvailableForTranslux4" :name="'icon-' + event.fosporttypename.replace(/ /g, '')" :colorName="'translux4'"></icon>
            <template v-if="headertype === 'DATE'">
              <template v-if="isDateToday">
                {{ $t('Today') }}
              </template>
              <template v-else-if="isDateTomorrow">
                {{ $t('Tomorrow') }}
              </template>
              <template v-else>
                {{ event.tsDate }}
              </template>
            </template>
            <template v-else>{{ event.fosporttypename || event.idfosporttype }}</template>
          </h2>
          <div class="names-date">
            <div class="listcode-date" :class="{'showparticipantlogo': teamLogoVisibility}">
              <span v-if="!(brand_translux4 || brand_translux3 || brand_translux2)" class="listcode">{{ listCode.away || '-' }}</span>
              <span class="time">
                <span>
                  <span v-if="!event.isawaitingstart" :class="{'live-icon': !event.isawaitingstart}">LIVE</span>
                  <span>{{ event.periodname }}</span>

                  <template v-if="['FOOTBALL', 'SOCCER', 'BASKETBALL', 'HANDBALL', 'ICE HOCKEY'].indexOf(event.idfosporttype) > -1">
                    <span class="time-counter" v-if="!matchTimer && event.istimeractive && event.matchcurrenttimeinmins">{{ event.matchcurrenttimeinmins }}'</span>

                    <match-time-display
                    v-if="matchTimer"
                    :timer="matchTimer"></match-time-display>
                  </template>
                </span>
              </span>
              <span v-if="!(brand_translux4 || brand_translux3 || brand_translux2)" class="listcode">{{ listCode.home || '-' }}</span>
            </div>
            <div v-if="!isSportReverseParticipants" class="names" :class="{'team-logos': teamLogoVisibility}">
              <span class="away" :class="{'server': isAwayServing}">
                <span v-if="brand_translux4 || brand_translux3 || brand_translux2" class="listcode">{{ listCode.away || '-' }}</span>
                <span v-if="showparticipantlogo" class="team-logo" :style="awayTeamLogoStyle"></span>
                <span class="team-name">{{ awayPlayer.name }}</span>
              </span>
              <span class="home" :class="{'server': isHomeServing}">
                <span v-if="brand_translux4 || brand_translux3 || brand_translux2" class="listcode">{{ listCode.home || '-' }}</span>
                <span v-if="showparticipantlogo" class="team-logo" :style="homeTeamLogoStyle"></span>
                <span class="team-name">{{ homePlayer.name}}</span>
              </span>
            </div>
            <div v-else class="names" :class="{'team-logos': teamLogoVisibility}">
              <span class="home" :class="{'server': isHomeServing}">
                <span v-if="brand_translux4 || brand_translux3 || brand_translux2" class="listcode">{{ listCode.home || '-' }}</span>
                <span v-if="showparticipantlogo" class="team-logo" :style="homeTeamLogoStyle"></span>
                <span class="team-name">{{ homePlayer.name}}</span>
              </span>
              <span class="away" :class="{'server': isAwayServing}">
                <span v-if="brand_translux4 || brand_translux3 || brand_translux2" class="listcode">{{ listCode.away || '-' }}</span>
                <span v-if="showparticipantlogo" class="team-logo" :style="awayTeamLogoStyle"></span>
                <span class="team-name">{{ awayPlayer.name }}</span>
              </span>
            </div>
          </div>
        </div>

        <div class="info" v-if="!hideScores">
          <table>
            <thead v-if="showheader === undefined || showheader">
              <tr class="header-row">
                <th v-if="event.idfosporttype !== 'TENNIS' || ((brand_white1 || brand_translux5) && event.idfosporttype === 'TENNIS')" class="final-result" v-text="(brand_white1 || brand_translux5) && event.idfosporttype === 'TENNIS' ? 'S' : $t('Results.FSC')"></th>

                <!-- SOCCER -->
                <th v-if="event.idfosporttype === 'SOCCER'" class="halftime">{{ $t('Results.HT') }}</th>

                <template v-if="event.idfosporttype === 'TENNIS' && awayPlayerScores.length > 0">
                  <th class="score serve"></th>
                  <th v-if="(brand_white1 || brand_translux5)" class="score set">G</th>
                  <th class="game">P</th>
                </template>

                <th v-if="['TENNIS', 'BASKETBALL', 'ICE HOCKEY', 'BASEBALL', 'NFL'].indexOf(event.idfosporttype) > -1" v-for="score in awayPlayerScores" class="period">
                  {{ getScoreKeyBySport(score, event.idfosporttype) }}
                </th>
              </tr>
            </thead>

            <tbody>
              <!-- AWAY TEAM -->
              <tr class="away">
                <td class="score match" v-if="event.idfosporttype !== 'TENNIS' || (brand_white1 || brand_translux5)">
                  <span v-if="!isSportReverseParticipants">{{ awayPlayerMainScore && awayPlayerMainScore.value }}</span>
                  <span v-else>{{ homePlayerMainScore && homePlayerMainScore.value }}</span>
                </td>

                <template v-if="event.idfosporttype === 'SOCCER'">
                  <td class="score halftime">
                    <span v-if="event.idfosbactiveperiod === 'FBL1HLF'"> - </span>
                    <span v-if="event.idfosbactiveperiod !== 'FBL1HLF'">
                      {{ soccerAwayHTScore && soccerAwayHTScore.value }}
                    </span>
                  </td>
                </template>

                <template v-if="event.idfosporttype === 'TENNIS' && awayPlayerScores.length > 0">
                  <td class="score serve">
                    <span v-if="awayPlayer.idfosblead === liveEvent.idfosbleadactive || awayPlayer.flag1">*</span>
                  </td>
                  <td v-if="(brand_white1 || brand_translux5)" class="score set">
                    <span>{{ awayPlayerTennisSetScores }}</span>
                  </td>
                  <td class="score game">
                    <span>{{ (!isTieBreakActive && tennisAwayPlayerGameScore && tennisAwayPlayerGameScore.value && gameScoreMap[tennisAwayPlayerGameScore.value]) || (tennisAwayPlayerGameScore && tennisAwayPlayerGameScore.value) }}</span>
                  </td>
                </template>

                <template v-if="['TENNIS', 'BASKETBALL', 'ICE HOCKEY', 'BASEBALL', 'NFL'].indexOf(event.idfosporttype) > -1">
                  <td class="score period" v-for="score in awayPlayerScores">
                    {{ getScore(score).value }}
                  </td>
                </template>
              </tr>

              <!-- HOME TEAM -->
              <tr class="home">
                <td class="score match" v-if="event.idfosporttype !== 'TENNIS' || (brand_white1 || brand_translux5)">
                  <span v-if="!isSportReverseParticipants">{{ homePlayerMainScore && homePlayerMainScore.value }}</span>
                  <span v-else>{{ awayPlayerMainScore && awayPlayerMainScore.value }}</span>
                </td>

                <template v-if="event.idfosporttype === 'SOCCER'">
                  <td class="score halftimescore">
                    <span v-if="event.idfosbactiveperiod === 'FBL1HLF'"> - </span>
                    <span v-if="event.idfosbactiveperiod !== 'FBL1HLF'">
                      {{ soccerHomeHTScore && soccerHomeHTScore.value }}
                    </span>
                  </td>
                </template>

                <template v-if="event.idfosporttype === 'TENNIS' && homePlayerScores.length > 0">
                  <td class="score serve">
                    <span v-if="homePlayer.idfosblead === liveEvent.idfosbleadactive || homePlayer.flag1">*</span>
                  </td>
                  <td v-if="(brand_white1 || brand_translux5)" class="score set">
                    <span>{{ homePlayerTennisSetScores }}</span>
                  </td>
                  <td class="score game" v-if="event.idfosporttype === 'TENNIS'">
                    <span>{{ (!isTieBreakActive && tennisHomePlayerGameScore && tennisHomePlayerGameScore.value && gameScoreMap[tennisHomePlayerGameScore.value]) || (tennisHomePlayerGameScore && tennisHomePlayerGameScore.value) }}</span>
                  </td>
                </template>

                <template v-if="['TENNIS', 'BASKETBALL', 'ICE HOCKEY', 'BASEBALL', 'NFL'].indexOf(event.idfosporttype) > -1">
                  <td class="score period" v-for="score in homePlayerScores">
                    {{ getScore(score).value }}
                  </td>
                </template>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="event-info" v-if="event.isoutright">
        <div class="info-head">
          <h2 class="sport-name">{{ event.idfosporttype }}</h2>
          <img v-if="(brand_translux4 && !isSportIconAvailableForTranslux4) || brand_translux4 || brand_translux3 || brand_translux2" class="logo" src="static/img/logo-event.png" alt="Logo">
          <icon v-if="brand_translux4 && isSportIconAvailableForTranslux4" :name="'icon-' + event.fosporttypename.replace(/ /g, '')" :colorName="'translux4'"></icon>
          <div class="names-date">
            <div class="listcode-date" :class="{'showparticipantlogo': teamLogoVisibility}">
              <span class="listcode">{{ listCode.away || '-' }}</span>
              <span class="time">
                <span v-if="event.idfobolifestate === 'O'">
                  <span class="day" v-if="isDateToday">{{ $t('Today') }}</span>
                  <span class="day" v-if="isDateTomorrow">{{ $t('Tomorrow') }}</span>
                  <span class="day" v-if="!isDateToday && !isDateTomorrow">{{ event.tsExpectedStart | moment(dateFormats.dayNameDayAndMonth) }}</span>
                  <span class="hour">{{ event.tsExpectedStart | moment(dateFormats.shortTime) }} {{ event.tsExpectedStart | moment('A') }}</span>

                </span>
                <span v-else>{{ $t('Finished') }}</span>
              </span>
              <span class="listcode">{{ listCode.home || '-' }}</span>
            </div>
            <div class="names">
              <span>
                <span class="team-name">{{ event.markets && event.markets[0] && event.markets[0].eventname }}</span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <markets v-if="popularMarkets.length > 0 || screenConfiguration.is2showeventsin2columns || screenConfiguration.is2showsingleevent"
             class="markets-container"
             :event="event"
             :markets="popularMarkets"
             :is2displayhorizontally="event.is2displayhorizontally"
             :showheader="showheader"></markets>
    </div>



    <div class="expanded-markets" :class="{'open': event.idfobolifestate === 'O' && expandedMarkets.length > 0}">
      <markets v-if="event.idfobolifestate === 'O' && expandedMarkets.length > 0"
               class="markets-container"
               :event="event"
               :markets="expandedMarkets"
               :is2displayhorizontally="event.is2displayhorizontally">

      </markets>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import markets from '@/components/bettingoffer/markets'
  import lib from '@/library'

  import Brands from '@/components/mixins/Brands'
  import BettingOffer from '@/components/mixins/BettingOffer'
  import TeamLogo from '@/components/mixins/TeamLogo'

  import MatchTimeDisplay from '@/components/bettingoffer/live/matchTimeDisplay'
  import Icon from '@/components/common/Icon'

  export default {
    name: 'live-event-info-component',

    props: [
      'event',
      'showheader',
      'headertype'
    ],

    components: {
      MatchTimeDisplay,
      markets,
      Icon
    },

    mixins: [
      Brands,
      TeamLogo,
      BettingOffer
    ],

    data () {
      return {
        periodScoreCounterNameBySport: {
          TENNIS: 'Set score'
        },
        gameScoreMap: {
          0: 0,
          1: 15,
          2: 30,
          3: 40,
          4: 'A'
        },
        collapsed: true
      }
    },

    computed: {
      hideScores () {
        return (window.ctsautoconf && window.ctsautoconf.HIDE_SCORES) || false
      },
      teamLogos () {
        return {
          logoHome: (this.event && this.event.logohome) || (this.event && this.event.participlogohome),
          logoAway: (this.event && this.event.logoaway) || (this.event && this.event.participlogoaway)
        }
      },
      liveEvent () {
        var liveEvent = this.liveEvents.find(ev => ev.idfoevent === this.event.idfoevent)
        return liveEvent || this.event
      },
      popularMarkets () {
        return (this.event.markets && this.event.markets.filter(mk => mk.isPopular)) || []
      },
      expandedMarkets () {
        return (this.event.markets && this.event.markets.filter(mk => mk.isExpanded)) || []
      },
      awayPlayer () {
        var players = this.liveEvent && (this.liveEvent.players || this.liveEvent.player)

        if (players) {
          return players.find(player => !player.type)
        } else {
          return undefined
        }
      },
      homePlayer () {
        var players = this.liveEvent && (this.liveEvent.players || this.liveEvent.player)

        if (players) {
          return players.find(player => player.type)
        } else {
          return undefined
        }
      },
      numberOfSets () {
        if (this.liveEvent.counter) {
          let counter = this.liveEvent.counter.find(c => c.name === 'Best of x sets')
          return (counter && counter.value) || 0
        } else {
          return undefined
        }
      },
      numOfPeriods () {
        var numofperiods = 0
        if (this.liveEvent.idfosporttype === 'TENNIS') {
          numofperiods = this.numberOfSets
        } else if (this.liveEvent.idfosporttype === 'BASKETBALL') {
          numofperiods = 4
        } else if (this.liveEvent.idfosporttype === 'ICE HOCKEY') {
          numofperiods = 3
        } else if (this.liveEvent.idfosporttype === 'BASEBALL') {
          numofperiods = 9
        } else if (this.liveEvent.idfosporttype === 'NFL') {
          numofperiods = 4
        }

        if (this.liveEvent.activeperiod && ['BBLEOT', 'BBLCOT', 'BBLNOT', 'HKYOVRT', 'HKYPNTY', 'BSBOVRT', 'UFBOVT'].indexOf(this.event.activeperiod.str) > -1) {
          numofperiods += 1
        }

        return numofperiods
      },
      tennisAwayPlayerGameScore () {
        if (this.awayPlayer && this.awayPlayer.counters) {
          return this.awayPlayer.counters.find(cnt => cnt.name === 'Game score')
        } else {
          return undefined
        }
      },
      tennisHomePlayerGameScore () {
        if (this.homePlayer && this.awayPlayer.counters) {
          return this.homePlayer.counters.find(cnt => cnt.name === 'Game score')
        } else {
          return undefined
        }
      },
      awayPlayerMainScore () {
        // No counter for sets, so I will use Main counter
        if (this.awayPlayer && this.awayPlayer.counters) {
          return this.awayPlayer.counters.find(counter => counter.ismain) || undefined
        } else {
          return undefined
        }
      },
      homePlayerMainScore () {
        if (this.homePlayer && this.homePlayer.counters) {
          return this.homePlayer.counters.find(counter => counter.ismain) || undefined
        } else {
          return undefined
        }
      },
      soccerAwayHTScore () {
        return this.awayPlayer.counters.find(cnt => cnt.name === 'HT result')
      },
      soccerHomeHTScore () {
        return this.homePlayer.counters.find(cnt => cnt.name === 'HT result')
      },
      awayPlayerScores () {
        if (this.awayPlayer) {
          if (!this.isLivewire() && this.awayPlayer.scores) {
            return this.awayPlayer.scores.filter(scr => scr)
          } else if (this.awayPlayer.counters) {
            let counters = this.awayPlayer.counters.filter(c => c.name === 'Set score' || c.name === 'Quarter Score' || c.name === 'Goals per period' || c.name === 'Inning score')
            let score = []
            if (counters) {
              counters.forEach((counter) => {
                if (counter.idfosbperiod && (!this.numOfPeriods || this.numOfPeriods >= parseInt(counter.idfosbperiod[this.activePeriodNumberPosition]))) {
                  score.push({
                    index: counter.idfosbperiod[this.activePeriodNumberPosition],
                    scorevalue: isNaN(this.activePeriodNumber) || this.activePeriodNumber < counter.idfosbperiod[this.activePeriodNumberPosition] ? '-' : counter.value
                  })
                }
              })
            }
            return Vue._.orderBy(score, 'index', 'asc')
          } else {
            return []
          }
        } else {
          return []
        }
      },
      awayPlayerTennisSetScores () {
        var score = this.getScoreForSet(this.awayPlayerScores, this.activePeriodNumber)

        if (score) {
          score = score.value
        }

        return score
      },
      homePlayerScores () {
        if (this.homePlayer) {
          if (!this.isLivewire() && this.homePlayer.scores) {
            return this.homePlayer.scores.filter(scr => scr)
          } else if (this.homePlayer.counters) {
            let counters = this.homePlayer.counters.filter(c => c.name === 'Set score' || c.name === 'Quarter Score' || c.name === 'Goals per period' || c.name === 'Inning score')
            let score = []
            if (counters) {
              counters.forEach((counter) => {
                if (counter.idfosbperiod && (!this.numOfPeriods || this.numOfPeriods >= parseInt(counter.idfosbperiod[this.activePeriodNumberPosition]))) {
                  score.push({
                    index: counter.idfosbperiod[this.activePeriodNumberPosition],
                    scorevalue: isNaN(this.activePeriodNumber) || this.activePeriodNumber < counter.idfosbperiod[this.activePeriodNumberPosition] ? '-' : counter.value
                  })
                }
              })
            }
            return Vue._.orderBy(score, 'index', 'asc')
          } else {
            return []
          }
        } else {
          return []
        }
      },
      homePlayerTennisSetScores () {
        var score = this.getScoreForSet(this.homePlayerScores, this.activePeriodNumber)

        if (score) {
          score = score.value
        }

        return score
      },
      activePeriodNumber () {
        if (this.event && this.event.idfosbactiveperiod) {
          return this.event.idfosporttype === 'BASKETBALL' && (this.event.idfosbactiveperiod === 'BBLEOT' || this.event.idfosbactiveperiod === 'BBLEHT')
            ? 4
            : this.event.idfosbactiveperiod[this.activePeriodNumberPosition]
        } else {
          return 0
        }
      },
      activePeriodNumberPosition () {
        return this.event.idfosporttype === 'BASKETBALL' ? 4 : 3
      },
      isTieBreakActive () {
        if (this.event.idfosporttype === 'TENNIS') {
          let counters = this.event.counter || this.event.counters || []
          let tbcounter = counters.filter(c => c.name === 'Tie-break active')[0]
          return (tbcounter && (parseInt(tbcounter.value) === 1))
        } else {
          return false
        }
      },
      matchTimer () {
        var self = this
        return (this.liveEvent && this.liveEvent.timers && this.liveEvent.timers.find(t => t.timername === 'MATCH' && t.idfosbperiod === self.event.idfosbactiveperiod)) || undefined
      },
      listCode () {
        var listCodes = (this.event.listcode && this.event.listcode.split('|')) || [this.event.listcode || '', '']
        return {
          away: listCodes[0] || '',
          home: listCodes[1] || ''
        }
      },
      isDateTomorrow () {
        return this.isTomorrow
      },
      isDateToday () {
        return this.isToday
      },
      isAwayServing () {
        return this.awayPlayer.idfosblead === this.liveEvent.idfosbleadactive || this.awayPlayer.flag1
      },
      isHomeServing () {
        return this.homePlayer.idfosblead === this.liveEvent.idfosbleadactive || this.homePlayer.flag1
      },
      isSportIconAvailableForTranslux4 () {
        // to be removed as soon as possible !!!
        return ['ICE HOCKEY', 'BASEBALL', 'BASKETBALL', 'FOOTBALL'].indexOf(this.event.idfosporttype) > -1
      },
      isSportReverseParticipants () {
        return ['SOCCER'].includes(this.event.idfosporttype) && this.brand_white1
      }
    },

    methods: {
      isLivewire () {
        return lib.WebSocketLiveService.isConnected && this.awayPlayer.counters && this.awayPlayer.counters.length > 0 && this.awayPlayer.counters[0].idfosbperiod
      },
      getScore (score) {
        return {
          key: (score && (score.index || score.key)) || null,
          value: (score && (score.scorevalue || score.value)) || 0
        }
      },
      getScoreForSet (scores, set) {
        var score = null

        if (scores) {
          scores.forEach(value => {
            if (value.index === set || value.key === set) {
              score = this.getScore(value)
            }
          })
        }

        return score
      },
      getScoreKeyBySport (score, idfosporttype) {
        var scr = this.getScore(score)
        switch (idfosporttype) {
          case 'NFL':
          case 'BASKETBALL':
            return scr.key < 5 ? scr.key : this.$t('Results.OT')
          case 'ICE HOCKEY':
            return scr.key < 4 ? scr.key : this.$t('Results.OT')
          case 'BASEBALL':
            return scr.key < 10 ? scr.key : this.$t('Results.OT')
          default:
            return scr.key
        }
      }
    }
  }
</script>
<style lang="stylus" scoped>

</style>



// WEBPACK FOOTER //
// src/components/bettingoffer/live/liveEvent.vue